<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.periods')"
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button
              class="btn btn-success"
              @click="neuerZeitraum"
              v-if="editable"
            >
              <span>{{ $t("global.new") }}</span>
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-secondary"
              @click="oeffneKalenderModal"
              v-if="editable"
              :disabled="selectedIds.length !== 1"
              :title="selectedIds !==1 ? $t('global.selectOnlyOne') : ''"
              >
              <font-awesome-icon class="mr-2" icon="fa-duotone" />
              <span>{{ $t("global.insertBreak") }}</span>
            </button>
          </div>
          <div class="mr-4">
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="editable"
              :disabled="selectedIds.length === 0"
              :title="selectedIds.length === 0 ? $t('global.selectminone') : ''"
            >
              <font-awesome-icon class="mr-2" icon="fa-duotone fa-trash" />
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div ref="tableParent">
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :items="zeitraumliste"
              :fields="fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-compare="sortDatum"
              :busy="isBusy"
              show-empty
              sort-icon-left
              fixed
              responsive
              sticky-header
              selectable
              select-mode="range"
              @row-dblclicked="details"
              small
              thead-tr-class="pointer"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(partnerschuleName)="row">
                <template v-if="row.item.istSchulverfuegbarkeit">
                  <span v-if="partnerschulen.length === 0">
                    {{ $t("global.noPartnerSchool") }}
                  </span>
                  <template v-else-if="partnerschulen.length === 1">
                    <div class="partnerschule-cell">{{ partnerschulen[0].name }}</div>
                  </template>
                  <template v-else>
                    <div class="partnerschule-cell">
                      {{ partnerschulen[0].name }}
                      <span class="expand-toggle" @click.stop="toggleExpand(row.item.id)">
                        {{ expandedRows[row.item.id] ? '▲' : '▼ +' + (partnerschulen.length - 1) }}
                      </span>
                    </div>
                    <template v-if="expandedRows[row.item.id]">
                      <div v-for="schule in partnerschulen.slice(1)" :key="schule.id" class="partnerschule-cell">
                        {{ schule.name }}
                      </div>
                    </template>
                  </template>
                </template>
              </template>

              <template v-slot:cell(partnerschuleResVon)="row">
                <template v-if="row.item.istSchulverfuegbarkeit && partnerschulen.length > 0">
                  <div v-if="!expandedRows[row.item.id] && partnerschulen.length > 1" class="partnerschule-cell">
                    {{ partnerschulen[0].reservationsfensterVon || '—' }}
                  </div>
                  <div v-else v-for="schule in partnerschulen" :key="schule.id" class="partnerschule-cell">
                    {{ schule.reservationsfensterVon || '—' }}
                  </div>
                </template>
              </template>

              <template v-slot:cell(partnerschuleResBis)="row">
                <template v-if="row.item.istSchulverfuegbarkeit && partnerschulen.length > 0">
                  <div v-if="!expandedRows[row.item.id] && partnerschulen.length > 1" class="partnerschule-cell">
                    {{ partnerschulen[0].reservationsfensterBis || '—' }}
                  </div>
                  <div v-else v-for="schule in partnerschulen" :key="schule.id" class="partnerschule-cell">
                    {{ schule.reservationsfensterBis || '—' }}
                  </div>
                </template>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <loeschen-modal
      id="zeitraum-loeschen-modal"
      @confirmed="zeitraumLoeschen"
      :selectedIds="Array.from(new Set(selectedIds))"
    />

    <zeitraum-modal
      :zeitraumProp="zeitraum"
      :id="id"
      :minDatum="minDatum"
      :maxDatum="maxDatum"
      :partnerschulen="partnerschulen"
    ></zeitraum-modal>

    <kalender-modal
      :minDatum="minDatum"
      :maxDatum="maxDatum"
      :kalenderDaten="selectedObjects.length === 1 ? selectedObjects[0] : {}"
      :showLegend="true"     
    />
  </div>
</template>
  
<script>
import AppApi from "@/api/AppApi";

import { apiErrorToAlert } from "@/utils/Errorhandler";
import { BSpinner } from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";

import LoeschenModal from "@/components/Modals/LoeschenModal";

import reiter from "@/mixins/Reiter";

import ZeitraumModal from "@/newviva/components/Modale/ZeitraumModal.vue";

import KalenderModal from "@/newviva/components/Modale/KalenderModal.vue";

export default {
  components: {
    ContainerHeadline,
    LoeschenModal,
    BSpinner,
    ZeitraumModal,
    KalenderModal,
  },
  mixins: [reiter],
  props: {
    id: {
      type: String,
      required: false,
    },
    firmaId: {
      type: String,
      required: false,
    },
    zeitraumliste: {
      type: Array,
      required: true,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    editable: {
      type: Boolean,
      required: true,
    },
    minDatum: {
      type: String,
      required: true,
    },
    maxDatum: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      page: 0,
      anzahlProPage: 100,
      sortBy: "von",
      sortDesc: false,
      isBusy: false,
      ladeFehler: false,
      selected: [],
      selectedIds: [],
      selectedObjects: [],
      zeitraum: {},
      einsaetze: [],
      partnerschulen: [],
      expandedRows: {},
    };
  },
  computed: {
    fields() {
      return [
        { key: "selected", label: "" },
        { key: "von", sortable: true, label: this.$t("global.From") },
        { key: "bis", sortable: true, label: this.$t("global.till") },
        { key: "einsatzplaetze", sortable: true, label: this.$t("global.numberOfYouths") },
        { key: "partnerschuleName", sortable: false, label: this.$t("global.partnerSchools") },
        { key: "partnerschuleResVon", sortable: false, label: this.$t("global.resFrom") },
        { key: "partnerschuleResBis", sortable: false, label: this.$t("global.resTill") },
        { key: "belegungsstatus.bezeichnung", sortable: true, label: this.$t("global.occupancystatus") },
      ];
    },
  },
  watch: {
    firmaId(val) {
      if (val) this.ladePartnerschulen();
    },
  },
  mounted() {
    // if (this.shown && this.zeitraumliste.length == 0) this.getZeitraeme();
    // this.$bus.$on("reload-zeitraeume", () => {
    //   this.getZeitraeme();
    // });

    this.$bus.$on("reset-zeitraum-selection", () => {
      this.selectedIds = [];
      this.selectedObjects = [];
    });

    this.getEinsaetze();
    this.ladePartnerschulen();

  },
  created() {},
  methods: {
    // getZeitraeme() {
    //   this.isBusy = true;

    //   AppApi.get("zeitraum/", {
    //     params: {
    //       angebotId: this.id,
    //     },
    //   })
    //     .then((response) => {
    //       this.zeitraumliste = response.data;
    //       this.ladeFehler = false;
    //     })
    //     .catch((e) => {
    //       this.$notify(apiErrorToAlert(e));
    //       this.ladeFehler = true;
    //     })
    //     .finally(() => {
    //       this.isBusy = false;
    //     });
    // },

    getEinsaetze() {
      if (this.id) {
        AppApi.get("/einsatzreiter", {
          params: {angebotId: this.id },
        }).then((response) => {
          this.einsaetze = response.data;
        });
      }
    },

    toggleExpand(id) {
      this.$set(this.expandedRows, id, !this.expandedRows[id]);
    },

    ladePartnerschulen() {
      if (!this.firmaId) return Promise.resolve();
      return AppApi.get("agriviva-firma/partnerschulen", {
        params: { hofId: this.firmaId },
      }).then((response) => {
        this.partnerschulen = response.data;
      });
    },

    details(zeitraum) {
      this.zeitraum = zeitraum;
      this.$nextTick(() => this.oeffneZeitraumModal());
    },

    oeffneZeitraumModal() {
      this.$bus.$emit("open-zeitraum-modal");
    },

    neuerZeitraum() {
      this.zeitraum = {
        id: null,
        angebot: this.id,
        von: null,
        bis: null,
        einsatzplaetze: null,
        belegungsstatus: null,
        istSchulverfuegbarkeit: false,
      };
      this.ladePartnerschulen().then(() => {
        this.$nextTick(() => this.oeffneZeitraumModal());
      });
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = true;
        });
      } else {
        this.$refs.selectableTable.items.forEach((item) => {
          item.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
        this.selectedObjects.push(row.item);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
        this.selectedObjects = this.selectedObjects.filter(
          (item) => item.id != row.item.id
        );
      }
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "zeitraum-loeschen-modal");
    },

    oeffneKalenderModal() {
      const zeitraum = this.selectedObjects[0];

          this.$bus.$emit("open-kalender-modal", {
            minDatum: zeitraum.von,  // vom Zeile-Objekt
            maxDatum: zeitraum.bis,  // bis vom Zeile-Objekt
            selectedZeitraum: zeitraum, 
            einsaetze: this.einsaetze.filter(e => {
              if (e.zeitraum?.id !== zeitraum.id) return false;
              const SPERRENDE_STATUSE = ["vermittelt", "im einsatz", "reserviert", "beendet", "abgeschlossen", "behörden eingereicht", "behörden offen", "behörden akzeptiert"];
              const bez = e.einsatzstatus?.bezeichnung?.toLowerCase() ?? "";
              return SPERRENDE_STATUSE.some(s => bez.startsWith(s));
            }),
          });
    },

    zeitraumLoeschen() {
      this.isBusy = true;

      AppApi.delete("zeitraum/", {
        data: this.selectedIds,
      })
        .then(() => {
          this.$emit("confirmed");
          this.selectedIds = [];
          this.$bus.$emit("reload-zeitraeume");
          // this.getZeitraeme();
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        })
        .finally(() => {
          this.isBusy = false;
        });
    },

    sortDatum(datumA, datumB, key) {
      if (key !== "von" && key !== "bis") {
        return false;
      }

      const parseDate = (str) => {
        if (!str) return 0;
        const parts = str.split(" ")[0].split(".");
        return parseInt(parts[2]) * 10000 + parseInt(parts[1]) * 100 + parseInt(parts[0]);
      };

      const vonA = parseDate(datumA.von);
      const vonB = parseDate(datumB.von);

      if (vonA !== vonB) return vonA - vonB;

      const bisA = parseDate(datumA.bis);
      const bisB = parseDate(datumB.bis);
      return bisA - bisB;
    },
  },
};
</script>

<style scoped>
.partnerschule-cell {
  font-weight: normal;
}
.expand-toggle {
  cursor: pointer;
  font-size: 0.85em;
  color: #666;
}
</style>
